import { Divider, Stack } from "@mui/material";
import type { BatchPaymentDetailDto } from "Infrastructure/Api/Api";
import { BatchPaymentHeader } from "Components/BatchPayments/BatchPaymentDetail/BatchPaymentHeader";
import { PaymentItemsTable } from "Components/BatchPayments/BatchPaymentDetail/PaymentItemsTable";

type Props = {
  data: BatchPaymentDetailDto;
};

export const BatchPaymentDetailContent = ({ data }: Props) => {
  return (
    <Stack gap={3}>
      <BatchPaymentHeader data={data} />
      <Divider />
      <PaymentItemsTable items={data.payments} />
    </Stack>
  );
};
